/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { DocumentModal } from '../../pages/dashboard/_modals/Futurisk/DocumentModal'
import { HelpDocument } from '../auth'

type Props = {
  className: string
  title: string
  description: string
  avatar: string
  link: string | undefined
  Documents: HelpDocument[];
}

const DocumentLinkWidget: React.FC<Props> = ({ className, title, description, avatar, link, Documents }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <a className={` hoverable`} onClick={() => setModalShow(true)}>
        
          <div className='border bg-light-primary border-primary border-dashed rounded 
                                                             py-3 px-4 me-6 mb-3 border-hover-success 
                                                            bg-hover-primary text-hover-white'>
            <div className='d-flex align-items-center'>
              <div className='fs-6 fw-bolder'> Documents </div>
            </div>
          </div>
        

      </a>

      <DocumentModal show={modalShow} handleClose={() => setModalShow(false)} Documents={Documents} />
    </>
  )


}

export { DocumentLinkWidget }
